"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = checkAndPolyfill;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
/* eslint-disable flowtype/require-valid-file-annotation */
/* global window document */

function polyfillButtonForm() {
  var El = window.Element;
  var elementProto = El.prototype;
  var matchesFn = ['webkit', 'ms', 'moz', 'o'].reduce(function (func, prefix) {
    if (func) return func;
    var prefixedFuncName = "".concat(prefix, "MatchesSelector");
    // eslint-disable-next-line no-prototype-builtins
    if (elementProto.hasOwnProperty(prefixedFuncName)) {
      return elementProto[prefixedFuncName];
    }
    return func;
  }, elementProto.matches);
  var buttonsSelector = 'button[form]';
  function passedThrough(evt) {
    var currentNode = evt.target;
    while (matchesFn && currentNode instanceof El) {
      if (matchesFn.call(currentNode, buttonsSelector)) {
        return currentNode;
      }
      currentNode = currentNode.parentNode;
    }
    return false;
  }
  document.addEventListener('click', function (evt) {
    if (!document.querySelectorAll("".concat(buttonsSelector, ",form")).length) return;
    var found = passedThrough(evt);
    if (!found) return;
    var form = document.getElementById(found.getAttribute('form'));
    if (!form) return;
    var event;
    if (typeof window.Event === 'function') {
      event = new Event('submit', {
        bubbles: true,
        cancelable: true
      });
    } else {
      // IE10
      event = document.createEvent('Event');
      event.initEvent('submit', true, true);
    }
    form.dispatchEvent(event);
  });
}
function checkAndPolyfill() {
  var whenDOMReady = new _promise.default(function (resolve) {
    if (document.readyState !== 'loading') {
      resolve();
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve();
      });
    }
  });
  whenDOMReady.then(function () {
    var sampleButton = document.createElement('button');
    var sampleForm = document.createElement('form');
    sampleForm.setAttribute('id', 'sample-form-for-polyfill');
    sampleButton.setAttribute('form', 'sample-form-for-polyfill');
    document.body.appendChild(sampleForm);
    document.body.appendChild(sampleButton);
    var isIE11 = !window.ActiveXObject && 'ActiveXObject' in window;
    var supportsButtonFormAttr = window.HTMLFormElement && sampleButton.form instanceof window.HTMLFormElement && !isIE11;
    document.body.removeChild(sampleForm);
    document.body.removeChild(sampleButton);
    if (!supportsButtonFormAttr) {
      polyfillButtonForm();
    }
  });
}